import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { Heading, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "../../../Design/useParseStyles";
import { defaultStyles } from "./defaultStyles";

interface H5Props extends ComponentPropsWithRef<"table"> {
  styles?: Record<string, StyleValue>;
  text: string;
}

export const H5 = forwardRef<HTMLTableElement, H5Props>(
  ({ text, styles = {}, ...rest }, ref) => {
    const inlineStyles = useParseStyles({
      baseStyles: {
        letterSpacing: defaultStyles.letterSpacing,
      },
      styles,
      defaultStyles,
    });

    return (
      <Section ref={ref} {...rest}>
        <Heading as="h5" style={inlineStyles}>
          {text}
        </Heading>
      </Section>
    );
  },
);

H5.displayName = "H5";
